var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLoginId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.43 17.06H1.12C0.5 17.06 0 16.56 0 15.94V14.85C0 12.19 1.76 9.81 4.5 8.63C3.63 7.7 3.14 6.46 3.14 5.14C3.14 2.31 5.44 0 8.28 0C11.12 0 13.42 2.31 13.42 5.14C13.42 6.46 12.93 7.69 12.06 8.63C14.8 9.81 16.56 12.18 16.56 14.85V15.94C16.56 16.56 16.06 17.06 15.44 17.06H15.43ZM1.46 15.6H15.09V14.85C15.09 12.5 13.16 10.34 10.4 9.6C10.12 9.52 9.91 9.29 9.87 9C9.83 8.71 9.96 8.42 10.21 8.27C11.3 7.6 11.96 6.43 11.96 5.14C11.96 3.11 10.31 1.46 8.28 1.46C6.25 1.46 4.6 3.11 4.6 5.14C4.6 6.43 5.25 7.6 6.35 8.27C6.6 8.42 6.73 8.71 6.69 9C6.65 9.29 6.44 9.53 6.16 9.6C3.4 10.34 1.47 12.5 1.47 14.85V15.6H1.46Z",
    fill: "#8E8EA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoginId);
export default __webpack_public_path__ + "static/media/ico-login-id.bbf6a68981f3bdcff4e2b0806fd9e204.svg";
export { ForwardRef as ReactComponent };